import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMe, useModule } from '../hooks/data.js';
import { useOnline } from './Checkliste.jsx';
import { Icon } from '../components/Icon.jsx';
import { AppSheet } from '../apps/AppSheet.jsx';
import { ZUSTAND } from '../apps/zustand.js';

const FILTER = [
  ['alle', 'Alle', () => true],
  ['aktiv', 'Aktiv', (x) => x.zustand === 'an'],
  ['verfuegbar', 'Verfügbar', (x) => ['verfuegbar', 'beantragt', 'nicht-verfuegbar'].includes(x.zustand)],
  ['bald', 'Bald', (x) => x.zustand === 'bald'],
];

/**
 * Marketplace «Apps»: alle Module mit Zustand. Tipp auf eine Karte öffnet die Details mit Einschalten, Beantragen
 * oder Interesse melden – je nach Zustand und Rolle (die API prüft beides selbst).
 */
export function Apps() {
  const me = useMe();
  const q = useModule();
  const navigate = useNavigate();
  const online = useOnline();
  const [filter, setFilter] = useState('alle');
  const [offen, setOffen] = useState(null);
  const passt = FILTER.find(([k]) => k === filter)[2];
  const module = (q.data?.module ?? []).filter(passt);
  const gewaehlt = offen ? q.data?.module.find((x) => x.id === offen) : null;

  return (
    <div className="app">
      <div className="scroll">
        <div className="swrap">
          <div className="row" style={{ gap: 12 }}>
            <button className="iconbtn" aria-label="Zurück" onClick={() => navigate(-1)}><Icon name="back" stroke={2.4} /></button>
            <div className="stack" style={{ gap: 0, minWidth: 0 }}>
              <span className="sub ellipsis" style={{ fontWeight: 700 }}>{me.data?.mandant?.name}</span>
              <h1 className="h1">Apps</h1>
            </div>
          </div>
          <p className="sub" style={{ fontSize: 14, marginTop: -6 }}>Module für eure App ein- und ausschalten oder beantragen.</p>
          <div className="segment vier" role="tablist" aria-label="Filter">
            {FILTER.map(([k, titel]) => (
              <button key={k} type="button" role="tab" aria-selected={filter === k} className={filter === k ? 'on' : ''} onClick={() => setFilter(k)}>{titel}</button>
            ))}
          </div>
          {q.isError && !q.data && <div className="empty" role="alert">{q.error.message}<button className="btn" onClick={() => q.refetch()}>Erneut versuchen</button></div>}
          {!q.data && !q.isError && <div className="skeleton" style={{ height: 240 }} />}
          {q.data && module.length === 0 && <div className="empty">Nichts in dieser Auswahl.</div>}
          <div className="mehrgrid">
            {module.map((x) => {
              const [text, art] = ZUSTAND[x.zustand] ?? ZUSTAND.bald;
              return (
                <button key={x.id} type="button" className="card mehrkachel" style={{ border: 'none', font: 'inherit', textAlign: 'left', cursor: 'pointer' }}
                  onClick={() => setOffen(x.id)} aria-label={`${x.titel}, ${text}`}>
                  <span className="mehrico"><Icon name={x.icon} size={26} stroke={2.2} /></span>
                  <span className="stack" style={{ gap: 4, flex: 1, minWidth: 0 }}>
                    <span className="h2">{x.titel}</span>
                    <span className="sub" style={{ fontSize: 13 }}>{x.kurz}</span>
                    <span><span className={`pill ${art}`}>{text}</span></span>
                  </span>
                  <Icon name="chevron" size={20} stroke={2.4} style={{ color: 'var(--muted-2)', flexShrink: 0 }} />
                </button>
              );
            })}
          </div>
        </div>
      </div>
      {gewaehlt && <AppSheet modul={gewaehlt} darfSchalten={q.data.darfSchalten} darfBeantragen={q.data.darfBeantragen} online={online} onClose={() => setOffen(null)} />}
    </div>
  );
}
